import { useState } from 'react'

import { ReactComponent as Code } from '../../../../assets/icons/code.svg'
import { IResponseContent } from '../../../../stores/responsesStore'
import Popup from '../../../Popup/Popup'

import ResponseYamlEditor from './ResponseYamlEditor/ResponseYamlEditor'

import styles from './response-yaml.module.scss'

interface IResponseYamlProps {
    message: IResponseContent
}

function ResponseYaml(props: IResponseYamlProps) {
    const { message } = props

    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button
                className={styles.responseYaml__btn}
                onClick={() => setIsOpen(true)}
            >
                <Code className={styles.responseYaml__icon} />
            </button>
            <Popup
                isOpen={isOpen}
                closePopup={() => setIsOpen(false)}
                className={styles.responseYaml__popup}
            >
                <ResponseYamlEditor
                    message={message}
                    closePopup={() => setIsOpen(false)}
                />
            </Popup>
        </>
    )
}

export default ResponseYaml
